import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';
import Request from '@api/request';

import type { OAuthAuthorizationRequest } from '@lib/oauth-authorization';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const Service = {
  // 帐号密码登录
  accountLogin: async (params: any) => {
    const res: any = await apiPost('/mg/users/login', params);
    return res;
  },
  // 手机号登录
  phoneLogin: async (params: any) => {
    const res: any = await apiPost('/mg/users/login_by_captcha', params);
    return res;
  },
  // 已登录会话换取一次性 OAuth 授权码。该响应不得经过通用响应日志。
  oauthAuthorize: async (params: OAuthAuthorizationRequest) => {
    const controller = new AbortController();
    const response = await Request(
      'post',
      '/mg/oauth/authorize',
      controller.signal,
      params,
    );
    let data: any = null;
    try {
      data = await response.json();
    } catch (_error) {
      // 非 JSON 错误由调用方按签发失败处理，不记录响应正文。
    }
    return { status: response.status, data };
  },
  // 登录-获取验证码
  phoneCaptcha: async (params: any) => {
    const res: any = await apiPost('/mg/users/login/captcha', params);
    return res;
  },
  // 注册-获取验证码
  msgCaptcha: async (params: any) => {
    const res: any = await apiPost('/mg/msg/captcha', params);
    return res;
  },
  // 修改密码 获取验证码
  resetCaptcha: async (params: any) => {
    const res: any = await apiPost('/mg/users/reset_password/captcha', params);
    return res;
  },
  // 注册
  register: async (params: any) => {
    const res: any = await apiPost('/mg/users/register', params);
    return res;
  },
  // 注册
  resetPassword: async (params: any) => {
    const res: any = await apiPost('/mg/users/reset_password', params);
    return res;
  },
  // 公司搜索
  searchCompany: async (companyName: string) => {
    const res: any = await apiGet(`/mg/company/search?keyword=${companyName}`);
    if (res.code !== 0 || isEmpty(res)) return [];
    return res.result;
  },
  // 注册完毕 - 选择行业
  chooseIndustry: async (token: string, params: any) => {
    const res: any = await apiPut(`/mg/users?access_token=${token}`, params);
    return res;
  },
};

export default Service;
